import lazyload from 'app/libs/lazyload';

export const RedirectPage = lazyload(() => import('../common/RedirectPage'));

export const CenterListPage = lazyload(() => import('./CenterListPage'));
export const AdCenterListPage = lazyload(() => import('./AdCenterListPage'));
export const MeetgoCenterListPage = lazyload(() => import('./MeetgoCenterListPage'));
export const CenterDetailPage = lazyload(() => import('./CenterDetailPage'));
export const SendMailPage = lazyload(() => import('./SendMailPage'));
